<template>
  <v-carousel cycle>
    <v-carousel-item v-for="(image, index) in images" :key="index" :src="image.src">
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'WhatsNewCarousel',
  data() {
    return{
    images: [
      {
        src: 'img/news_dialog/bulk-upload-1.png'
      },
      {
        src: 'img/news_dialog/bulk-upload-2.png'
      }
    ]
    }
    
  }
}
</script>
